<template>
  <div class="main-content">
    <!-- 标题 -->
    <div class="title-area">
      <span class="text">{{
        $t(userinfo.email ? 'titles.resetEmail' : 'titles.bindEmail')
      }}</span>
    </div>
    <!-- 表单 -->
    <div class="form-area">
      <el-form
        ref="form"
        :model="formData"
        :rules="rules"
        label-position="right"
        label-width="100px"
      >
        <el-form-item
          :label="$t('pages.login.email')"
          prop="email"
          v-if="userinfo.email"
        >
          <el-input v-model="formData.email" disabled></el-input>
        </el-form-item>
        <el-form-item
          class="vcode-item"
          :label="$t('pages.login.CAPTCHA')"
          prop="vcode"
          v-if="userinfo.email"
        >
          <el-input v-model="formData.vcode"></el-input>
          <div class="v-btn-area">
            <el-button
              plain
              :type="disabled ? 'info' : 'primary'"
              @click="getVCode"
              >{{ txt }}</el-button
            >
          </div>
        </el-form-item>
        <el-form-item :label="$t('pages.login.email2')" prop="newEmail">
          <el-input v-model="formData.newEmail"></el-input>
        </el-form-item>
        <el-form-item
          class="vcode-item"
          :label="$t('pages.login.CAPTCHA')"
          prop="newVcode"
        >
          <el-input v-model="formData.newVcode"></el-input>
          <div class="v-btn-area">
            <el-button
              plain
              :type="newDisabled ? 'info' : 'primary'"
              @click="getNewVCode"
              >{{ NewTxt }}</el-button
            >
          </div>
        </el-form-item>
        <el-form-item class="row">
          <el-button type="primary" v-loading="isLoading" @click="submitForm">{{
            $t('common.submit')
          }}</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {
  selectVcode,
  checkUsername,
  updateUserinfoTelOrEmail,
} from '@/api/common';
let timer = null;
export default {
  data() {
    return {
      emailStatus: false,
      formData: {
        email: '',
        vcode: '',
        newEmail: '',
        newVcode: '',
      },
      rules: {
        newEmail: [
          {
            validator: (rule, value, callback) => {
              if (
                /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9\\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(
                  value
                )
              ) {
                checkUsername({
                  mail: this.formData.newEmail,
                })
                  .then(() => {
                    this.emailStatus = true;
                    callback();
                  })
                  .catch(() => {
                    this.emailStatus = false;
                    callback(new Error(this.$t('pages.login.plh_email_used')));
                  });
              } else {
                callback(new Error(this.$t('pages.login.plh_email')));
              }
            },
          },
        ],
        newVcode: [
          {
            required: true,
            message: this.$t('pages.login.plh_captcha'),
            trigger: 'blur',
          },
        ],
      },
      txt: this.$t('pages.login.send'),
      NewTxt: this.$t('pages.login.send'),
      disabled: false,
      newDisabled: false,
      isLoading: false,
    };
  },
  computed: {
    userinfo() {
      return this.$store.state.userinfo;
    },
  },
  methods: {
    submitForm() {
      if (this.isLoading) return;
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          try {
            this.isLoading = true;
            await updateUserinfoTelOrEmail({
              oldCaptcha: this.formData.vcode,
              newCaptcha: this.formData.newVcode,
              mail: this.formData.newEmail,
            });
            this.isLoading = false;
            this.$message.success(
              this.userinfo.email
                ? this.$t('pages.login.plh_modify_email')
                : this.$t('pages.login.plh_bind_email')
            );
            this.$store.commit('setUserinfoEmail', this.formData.newEmail);
            this.$router.push('/personal/my-info');
          } catch (error) {
            console.log(error);
            this.isLoading = false;
          }
        } else {
          return false;
        }
      });
    },
    showTime() {
      this.disabled = true;
      let time = 60;
      this.txt = `${this.$t('pages.login.resend')}(${time})`;
      timer = setInterval(() => {
        if (time <= 0) {
          clearInterval(timer);
          this.txt = this.$t('pages.login.send');
          this.disabled = false;
          return;
        }
        this.txt = `${this.$t('pages.login.resend')}(${--time})`;
      }, 1000);
    },
    async getVCode() {
      if (!this.disabled) {
        if (
          /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9\\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(
            this.formData.email
          )
        ) {
          try {
            await selectVcode({
              mail: this.formData.email,
              type: 1,
            });
            this.showTime();
            this.$message({
              message: this.$t('pages.login.plh_send'),
              type: 'success',
            });
          } catch (error) {
            console.log(error);
          }
        } else {
          this.$refs['form'].validateField('email');
          return false;
        }
      }
    },
    showNewTime() {
      this.newDisabled = true;
      let time = 60;
      this.NewTxt = `${this.$t('pages.login.resend')}(${time})`;
      timer = setInterval(() => {
        if (time <= 0) {
          clearInterval(timer);
          this.NewTxt = this.$t('pages.login.send');
          this.newDisabled = false;
          return;
        }
        this.NewTxt = `${this.$t('pages.login.resend')}(${--time})`;
      }, 1000);
    },
    async getNewVCode() {
      if (!this.newDisabled) {
        if (
          /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9\\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(
            this.formData.newEmail
          )
        ) {
          if (this.emailStatus) {
            try {
              await selectVcode({
                mail: this.formData.newEmail,
                type: 1,
              });
              this.showNewTime();
              this.$message({
                message: this.$t('pages.login.plh_send'),
                type: 'success',
              });
            } catch (error) {
              console.log(error);
            }
          }
        } else {
          this.$refs['form'].validateField('newEmail');
          return false;
        }
      }
    },
  },
  created() {
    this.formData.email = this.userinfo.email ? this.userinfo.email : '';
    if (this.formData.email) {
      this.rules.vcode = [
        {
          required: true,
          message: this.$t('pages.login.plh_captcha'),
          trigger: 'blur',
        },
      ];
    }
  },
};
</script>

<style lang="scss" scoped>
.main-content {
  .title-area {
    width: 454px;
    margin: 0 auto 70px;
    position: relative;
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    .text {
      display: inline-block;
      padding: 5px 30px;
      background: #ffffff;
      position: relative;
      line-height: 1;
    }
    &::before {
      content: '';
      position: absolute;
      width: 100%;
      height: 1px;
      background: #e6e6e6;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .form-area {
    width: 386px;
    margin: 0 auto;
    .el-form-item {
      &.vcode-item {
        ::v-deep .el-form-item__content {
          display: flex;
          align-items: center;
          .el-input {
            width: 210px !important;
            margin-right: 12px;
            input {
              width: 100%;
            }
          }
          .v-btn-area {
            text-align: right;
            cursor: pointer;
            img {
              width: 87px;
              height: 40px;
            }
          }
        }
      }
      &.row {
        margin-top: 50px;
        ::v-deep .el-form-item__content {
          margin-left: 0 !important;
          .el-button {
            width: 100%;
            color: $text-color-black;
            font-size: 18px;
          }
        }
      }
    }
  }
}
</style>
